import { Button, StyledText } from "../../../../components/common";
import { BackIcon, CloseIcon, NoticeIcon } from "../../../../components/svgs";
import { useTheme, useTrivia } from "../../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useState } from "react";

const FastestFingerInfoModal = ({ onBackDropClick }) => {
  const { themeContext, theme } = useTheme();
  const [showTriviaInfo, setShowTriviaInfo] = useState();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  return (
    <>
      <div>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            top: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
          }}
          onClick={onBackDropClick}
        ></div>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            width: "100%",
            bottom: 0,
          }}
        >
          <div
            style={{
              boxSizing: "border-box",
              padding: "20px",
              height: "60%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "white",
              marginTop: "70%",
              borderTopRightRadius: 15,
              borderTopLeftRadius: 15,
            }}
          >
            <div
              style={{
                width: 50,
                height: 8,
                backgroundColor: "#cbcbcb",
                borderRadius: 10,
              }}
            />
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                marginTop: 5,
                marginBottom: 5,
              }}
            >
              <div onClick={onBackDropClick}>
                <BackIcon fill="transparent" />
              </div>
              <div onClick={onBackDropClick} >
                <CloseIcon fill="black" />
              </div>
            </div>

            <StyledText style={{ fontSize: 20 }}>
              Fastest finger is here on Pulse!
            </StyledText>

            <StyledText style={{ fontSize: 40, margin: 0 }}>🤩</StyledText>

            <StyledText
              style={{
                textAlign: "center",
                fontFamily: "MTNRegular",
                paddingInline: 15,
              }}
            >
              Win <span style={{ fontFamily: "MTNMedium" }}>free airtime</span>{" "}
              in the blink of an eye. It's as simple as it sounds: be the
              quickest recharge and you'll be rewarded with{" "}
              <span style={{ fontFamily: "MTNMedium" }}>
                instant airtime credit!
              </span>
            </StyledText>
            <Button
              style={{ backgroundColor: background, width: "80%" }}
              onClick={() => history.push('/fastest_finger')}
            >
              <StyledText color="white">Check it out</StyledText>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FastestFingerInfoModal;
